import styled from '@emotion/styled';
import { MEDIA_QUERIES, SPACER } from 'radiance-ui/lib/constants';
import { css } from '@emotion/react';

import { LOCAL_COLORS } from 'styles/constants';
import { ReactComponent as AccordionSvg } from '../images/accordion.svg';

export const QuestionContainer = styled.div`
  align-items: center;
  display: flex;
  border-top: 1px solid ${LOCAL_COLORS.textDefault};
  font-weight: bold;
  justify-content: space-between;
  padding: 12px 0 ${SPACER.base} 0;

  &:hover {
    cursor: pointer;
  }

  ${MEDIA_QUERIES.lgUp} {
    border-top-width: 2px;
    font-size: ${SPACER.large};
    padding: ${SPACER.base} 0 20px 0;
  }
`;

export const AccordionToggle = styled(AccordionSvg)<{ isopen: boolean }>`
  min-height: 24px;
  margin-left: 4px;
  min-width: 24px;
  color: var(--text-color);
  height: 1.5rem;
  margin-left: 0.25rem;
  transform: ${({ isOpen }) => (isOpen ? 'none' : 'rotate(180deg)')};
  width: 1.5rem;

  ${MEDIA_QUERIES.lgUp} {
    height: 2rem;
    margin-left: 0.375rem;
    width: 2rem;
  }
`;

export const AnswerContainer = styled.div<{
  isOpen: boolean;
  themeType: string;
}>`
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  font-size: ${SPACER.medium};
  padding-bottom: ${SPACER.xlarge};

  ${MEDIA_QUERIES.mdUp} {
    ${({ themeType }) => (themeType === 'secondary' ? 'max-width: 100%' : '')};
  }

  ${MEDIA_QUERIES.lgUp} {
    font-size: 1rem;
    padding-bottom: ${SPACER.xlarge};
  }
`;

export const QuestionBox = styled.div`
  cursor: pointer;

  :not(:first-of-type) {
    margin-top: ${SPACER.xlarge};
  }

  ${MEDIA_QUERIES.mdUp} {
    align-items: flex-start;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
  }
`;

export const Question = styled.div<{ themeType: string }>`
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-flow: row nowrap;
  font-weight: 700;
  justify-content: space-between;
  margin: ${SPACER.xsmall} 0 ${SPACER.small};
  padding: ${SPACER.medium} 0 ${SPACER.small};
  width: 100%;
  font-weight: 700;
  padding: ${SPACER.medium} 0px ${SPACER.small};

  sup {
    font-size: 0.75rem;
  }
`;

export const wrapQuestionStyles = css`
  color: var(--text-color);
  white-space: normal;
`;

export const answerStyles = css`
  color: var(--text-color);
  font-weight: 400;
  opacity: 0.6;
  padding: ${SPACER.small} 0 ${SPACER.medium};

  p:not(:last-child) {
    padding-bottom: ${SPACER.large};
  }
`;

export const iconStyles = css`
  margin-left: auto;
  transition: transform 200ms ease-in-out;

  circle {
    fill: transparent;
    stroke-width: 3px;
  }
`;

export const disclaimerStyles = css`
  font-style: italic;
  font-weight: normal;
  opacity: 0.6;
`;
